// manage ID of the current medical staff
export const storeStaffId = (id) => {
    window.localStorage.setItem("current_staff_id", id);
    //log token
    console.log(id);
};
export const getStaffId = () => {
    //log token
    return parseInt(window.localStorage.getItem("current_staff_id"));
};


// manage name of the current medical staff
export const storeStaffName = (name) => {
    window.localStorage.setItem("current_staff_name", name);
    //log token
    console.log(name);
};
export const getStaffName = () => {
    //log token
    return window.localStorage.getItem("current_staff_name");
};



// manage surname of the current medical staff
export const storeStaffSurname = (Surname) => {
    window.localStorage.setItem("current_staff_surname", Surname);
    //log token
};

export const getStaffSurname = () => {
    //log token
    return window.localStorage.getItem("current_staff_surname");
};

// manage email of the current medical staff
export const storeStaffEmail = (email) => {
    window.localStorage.setItem("current_staff_email", email);
    //log token
    console.log(email);
};
export const getStaffEmail = () => {
    //log token
    return window.localStorage.getItem("current_staff_email");
};

// manage fiscal code of the current medical staff
export const storeStaffFiscalCode = (fiscalCode) => {
    window.localStorage.setItem("current_staff_fiscal_code", fiscalCode);
};
export const getStaffFiscalCode = () => {
    return window.localStorage.getItem("current_staff_fiscal_code");
}

// manage the authority of the current medical staff
export const storeStaffAuthority = (authority) => {
    window.localStorage.setItem("current_staff_authority", authority);
};
export const getStaffAuthority = () => {
    return window.localStorage.getItem("current_staff_authority");
}

